import { getImageCopyData } from "../image/imageFunctions";
import { useImageStore } from "../image/images.store";
import { getScenarioEndCopyData } from "../scenarioEnd/scenarioEndFunctions";
import { useScenarioEndStore } from "../scenarioEnd/scenarioEnds.store";
import type { ScenarioItem } from "./ScenarioItem";

export function getScenarioCopyData(scenario: ScenarioItem) {
  const data = [];

  // copy images
  const imageStore = useImageStore();
  if (scenario.startImageId) {
    const image = imageStore.items[scenario.startImageId];
    data.push(...getImageCopyData(image));
  }
  if (scenario.endImageId) {
    const image = imageStore.items[scenario.endImageId];
    data.push(...getImageCopyData(image));
  }

  data.push(scenario);

  // add ends - ends should be copied AFTER the scenario,
  // so that the copied ends are linked to the copied scenario
  const scenarioEndStore = useScenarioEndStore();
  const ends = scenarioEndStore.byScenario[scenario.id] || [];
  if (ends.length > 0) {
    for (const end of ends) {
      data.push(...getScenarioEndCopyData(end));
    }
  }

  return data;
}
